import { handleAxiosError } from "../common/handleAxiosError";
import { projectsApiClient } from "../common/axiosInstanceProjects";
import { ISectionFormData } from "./types";

export const createSection = async (formData: ISectionFormData) => {
  try {
    const data = await projectsApiClient.post("/sections", formData)
    return data;
  } catch (error) {
    handleAxiosError(error, "Error al crear el proyecto");
  }
};
